import { useEffect, useState } from "react";
import { GraduationCap, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

export function CoachPrefsCard() {
  const [prefs, setPrefs] = useState(null);

  useEffect(() => { api.get("/coach/prefs").then((r) => setPrefs(r.data)).catch(() => setPrefs([])); }, []);

  const remove = async (id) => {
    try {
      await api.delete(`/coach/prefs/${id}`);
      setPrefs((p) => p.filter((x) => x.id !== id));
      toast.success("The coach can suggest this again");
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <section className="rounded-2xl border bg-white p-6 sm:p-7" data-testid="coach-prefs-card">
      <div className="flex items-center gap-2 mb-1">
        <GraduationCap className="h-4 w-4 text-primary" />
        <h2 className="text-lg font-semibold">Coach preferences</h2>
      </div>
      <p className="text-sm text-slate-500 mb-5">
        Fixes you told the BCBA Coach not to suggest. It will still flag anything insurance requires for an audit.
      </p>
      {prefs === null ? null : prefs.length === 0 ? (
        <p className="rounded-xl border border-dashed p-4 text-sm text-slate-500" data-testid="coach-prefs-empty">
          Nothing yet — tap "Don't suggest this" on a coach fix to add one.
        </p>
      ) : (
        <ul className="divide-y rounded-xl border" data-testid="coach-prefs-list">
          {prefs.map((p) => (
            <li key={p.id} className="flex items-start gap-3 p-3" data-testid={`coach-pref-${p.id}`}>
              <div className="flex-1 min-w-0 text-sm">
                {p.section && <span className="mr-2 rounded bg-secondary px-1.5 py-0.5 text-[11px] font-semibold uppercase text-primary">{p.section}</span>}
                <span className="text-slate-800">{p.problem}</span>
                {p.example && <div className="mt-1 truncate text-xs text-slate-500">e.g. "{p.example}"</div>}
              </div>
              <Button size="sm" variant="ghost" className="h-8 rounded-full text-slate-500 hover:text-red-600" onClick={() => remove(p.id)} data-testid={`coach-pref-delete-${p.id}`}>
                <Trash2 className="h-3.5 w-3.5 mr-1" />Remove
              </Button>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
